import { createAction } from 'redux-actions';

import {
  SEND_VERIFICATION_CODE,
  SEND_VERIFICATION_CODE_SUCCESS,
  SEND_VERIFICATION_CODE_ERROR,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
  LOAD_ONSITE_BOOKING_SLOT,
  LOAD_ONSITE_BOOKING_SLOT_SUCCESS,
  LOAD_ONSITE_BOOKING_SLOT_ERROR,
  HOLD_ONSITE_BOOKING_SLOT,
  HOLD_ONSITE_BOOKING_SLOT_SUCCESS,
  HOLD_ONSITE_BOOKING_SLOT_ERROR,
  RELEASE_ONSITE_BOOKING_SLOT,
  RELEASE_ONSITE_BOOKING_SLOT_SUCCESS,
  RELEASE_ONSITE_BOOKING_SLOT_ERROR,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  UPLOAD_PATIENT_SIGNATURE,
  UPLOAD_PATIENT_SIGNATURE_SUCCESS,
  UPLOAD_PATIENT_SIGNATURE_ERROR,
  RESET_CURRENT_HOLDING_SLOT,
  RESET_SELECTED_ONSITE_BOOKING_SLOT,
} from './type';

//Send Verification Code

export const sendVerificationCodeAction = createAction(SEND_VERIFICATION_CODE);
export const sendVerificationCodeSuccessAction = createAction(
  SEND_VERIFICATION_CODE_SUCCESS,
);
export const sendVerificationCodeErrorAction = createAction(
  SEND_VERIFICATION_CODE_ERROR,
);

//Verify code
export const verifyCodeAction = createAction(VERIFY_CODE);
export const verifyCodeSuccessAction = createAction(VERIFY_CODE_SUCCESS);
export const verifyCodeErrorAction = createAction(VERIFY_CODE_ERROR);

//Onsite booking slot
export const loadOnsiteBookingSlotAction = createAction(
  LOAD_ONSITE_BOOKING_SLOT,
);
export const loadOnsiteBookingSlotSuccessAction = createAction(
  LOAD_ONSITE_BOOKING_SLOT_SUCCESS,
);
export const loadOnsiteBookingSlotErrorAction = createAction(
  LOAD_ONSITE_BOOKING_SLOT_ERROR,
);

//Hold slot
export const holdOnsiteBookingSlotAction = createAction(
  HOLD_ONSITE_BOOKING_SLOT,
);
export const holdOnsiteBookingSlotSuccessAction = createAction(
  HOLD_ONSITE_BOOKING_SLOT_SUCCESS,
);
export const holdOnsiteBookingSlotErrorAction = createAction(
  HOLD_ONSITE_BOOKING_SLOT_ERROR,
);

//Release slot
export const releaseOnsiteBookingSlotAction = createAction(
  RELEASE_ONSITE_BOOKING_SLOT,
);
export const releaseOnsiteBookingSlotSuccessAction = createAction(
  RELEASE_ONSITE_BOOKING_SLOT_SUCCESS,
);
export const releaseOnsiteBookingSlotErrorAction = createAction(
  RELEASE_ONSITE_BOOKING_SLOT_ERROR,
);

//Save selected slot
export const saveOnsiteSelectedBookingSlotAction = createAction(
  SAVE_SELECTED_ONSITE_BOOKING_SLOT,
);
export const saveOnsiteSelectedBookingSlotSuccessAction = createAction(
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS,
);
export const saveOnsiteSelectedBookingSlotErrorAction = createAction(
  SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR,
);

//Book onsite appointment slot
export const bookAppointmentAction = createAction(BOOK_APPOINTMENT);
export const bookAppointmentSuccessAction = createAction(
  BOOK_APPOINTMENT_SUCCESS,
);
export const bookAppointmentErrorAction = createAction(BOOK_APPOINTMENT_ERROR);

export const uploadPatientSignatureAction = createAction(
  UPLOAD_PATIENT_SIGNATURE,
);
export const uploadPatientSignatureSuccessAction = createAction(
  UPLOAD_PATIENT_SIGNATURE_SUCCESS,
);
export const uploadPatientSignatureErrorAction = createAction(
  UPLOAD_PATIENT_SIGNATURE_ERROR,
);

export const resetCurrentHoldingSlotAction = createAction(
  RESET_CURRENT_HOLDING_SLOT,
);

export const resetSelectedOnsiteBookingSlotAction = createAction(
  RESET_SELECTED_ONSITE_BOOKING_SLOT,
);
